'use client'

import React, { createContext, useState, useContext, ReactNode } from 'react'

interface SidebarContextType {
  isOpen: boolean
  toggleSidebar: () => void
  isHovering: boolean
  setIsHovering: (isHovering: boolean) => void
  recentlyClicked: boolean
  setRecentlyClicked: (recentlyClicked: boolean) => void
}

const SidebarContext = createContext<SidebarContextType>({
  isOpen: false,
  toggleSidebar: () => {},
  isHovering: false,
  setIsHovering: () => {},
  recentlyClicked: false,
  setRecentlyClicked: () => {},
})

interface SidebarProviderProps {
  children: ReactNode
}

export const SidebarProvider: React.FC<SidebarProviderProps> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isHovering, setIsHovering] = useState(false)
  const [recentlyClicked, setRecentlyClicked] = useState(false)

  const toggleSidebar = () => {
    setIsOpen(!isOpen)
  }

  return (
    <SidebarContext.Provider
      value={{
        isOpen,
        toggleSidebar,
        isHovering,
        setIsHovering,
        recentlyClicked,
        setRecentlyClicked,
      }}
    >
      {children}
    </SidebarContext.Provider>
  )
}

export const useSidebar = () => useContext(SidebarContext)
